//JS Imports
import { windowIsSmallerThan, toggleDarkMode } from './helpers'
import Lenis from 'lenis'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

//Lenis
const lenis = new Lenis({
    duration: 1.3,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
})

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

//Start raf loop    
requestAnimationFrame(raf)

jQuery(document).ready(function ($) { 

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      lenis.scrollTo(this.getAttribute('href'))
    });
  })
  
  // Add Lenis Prevent to Mobile Menu
  $(document).on('click', '#mobile-menu-control-wrapper .menu-toggle', function() {
    if ( $('.mobile-menu-open').length > 0 ) {
      lenis.stop();
      $('#site-navigation').attr("data-lenis-prevent", "true");
    } else {
      lenis.start();
      $('#site-navigation').removeAttr("data-lenis-prevent");
    }
  });

})
